import styled from 'styled-components';

export default styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(
    --pf-t--global--background--color--primary--default,
    var(--pf-v6-global--BackgroundColor--100, #fff)
  );
  z-index: 400;
`;
